import { render } from "./ClientDropdown.vue?vue&type=template&id=aab1ae20"
import script from "./ClientDropdown.vue?vue&type=script&lang=js"
export * from "./ClientDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__